import styled from "styled-components";

export const StyledModalBodyT1 = styled.div`
  &.bulk {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 24px;
    padding: 16px 16px 48px 16px;
  }

  &.confirm-modal-msg {
    padding: 16px;
  }
`;
